<template>
  <vue-multiselect :options="options"
                   :track-by="trackBy"
                   :label="label"
                   :searchable="false"
                   :allowEmpty="true"
                   :multiple="multiple"
                   :value="selected"
                   @input="handleInput"/>
</template>

<script>
import filter from '../../mixins/filter';

export default {
  mixins: [filter],
};
</script>
